var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserpinkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.875,
    height: 17,
    viewBox: "48.563 357.5 14.875 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 366a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Zm-1.517 1.594c-3.27 0-5.92 2.65-5.92 5.92 0 .544.441.986.986.986H62.45a.986.986 0 0 0 .986-.986c0-3.27-2.65-5.92-5.92-5.92h-3.034Z",
    fill: "#df1681",
    fillRule: "evenodd",
    "data-name": "user-solid"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserpinkicon);
export default __webpack_public_path__ + "static/media/userpinkicon.f15f46505b6985b2e819903917312ad1.svg";
export { ForwardRef as ReactComponent };